"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatSessionStatus = exports.SocketEvent = exports.MessageDirection = void 0;
var MessageDirection;
(function (MessageDirection) {
    MessageDirection["OUTBOUND"] = "OUTBOUND";
    MessageDirection["INBOUND"] = "INBOUND";
})(MessageDirection = exports.MessageDirection || (exports.MessageDirection = {}));
var SocketEvent;
(function (SocketEvent) {
    SocketEvent["CHAT_SESSION_START"] = "chat:session:start";
    SocketEvent["CHAT_SESSION_END"] = "chat:session:end";
    SocketEvent["CHAT_INBOUND_MESSAGE"] = "chat:in:message";
    SocketEvent["CHAT_OUTBOUND_MESSAGE"] = "chat:out:message";
    SocketEvent["CHAT_USER_ASSIGN"] = "chat:user:assign";
    SocketEvent["CHAT_USER_STATUS"] = "chat:user:status";
})(SocketEvent = exports.SocketEvent || (exports.SocketEvent = {}));
var ChatSessionStatus;
(function (ChatSessionStatus) {
    ChatSessionStatus["PENDING"] = "PENDING";
    ChatSessionStatus["ACTIVE"] = "ACTIVE";
    ChatSessionStatus["ENDED"] = "ENDED";
})(ChatSessionStatus = exports.ChatSessionStatus || (exports.ChatSessionStatus = {}));
